<template>
	<div class="content">
		<h3>经销商入库</h3>
		<div class="item">
			<el-form ref="form" style="width:460px" :model="form" :rules="rules" label-width="100px">
				<el-form-item label="入库单号" prop="username">
					<el-input  v-model="form.username"></el-input>
				</el-form-item>
				<el-form-item label="入库库房" prop="password">
					<el-select v-model="form.factoryID" placeholder="请选择">
						<el-option
						v-for="item in factory"
						:key="item.FactoryID"
						:label="item.FactoryName"
						:value="item.FactoryID">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="入库类型" prop="factoryID">
					<el-select v-model="form.factoryID" placeholder="请选择">
						<el-option
						v-for="item in storage"
						:key="item.type"
						:label="item.storage"
						:value="item.type">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label=" ">
					<el-radio  :label='1'>扫描操作</el-radio>
					<el-radio  :label='0'>文件操作</el-radio>
				</el-form-item>
				<el-form-item label="操作物流码">
					<div style="width: 250px;">
						<el-button icon="el-icon-search" type="primary">选择文件</el-button>
						<el-button icon="el-icon-upload" type="primary">上传文件</el-button>
					</div>
				</el-form-item>
				<el-form-item label="备注" prop="note">
					<el-input type="textarea" ></el-input>
				</el-form-item>
			</el-form>
			
			<span style="margin: 0 0 20px 100px;">
				<el-button @click="restForm" type="warning">重 置</el-button>
				<el-button type="primary" @click="SetStorage">保 存</el-button>
			</span>
		</div>
	</div>
</template>

<script>
export default {
	data(){
		return {
			form:{
				CID:'',
				factoryID:'',
				username:'',
				password:'',
				confirm:'',
				name:'',
				sex:'',
				tel:'',
				warehouse:'',
				state:'',
				isAgcy:'',
				Agcyname:''
			},
			rules: {
        		factoryID:[
          			{ required: true, message: '请选择正确的工厂', trigger: 'change' }
        		],
        		username:[
          			{ required: true, message: '请输入用户名', trigger: 'blur' }
        		],
        		password:[
          			{ required: true, message: '请输入密码', trigger: 'blur' }
        		]
			},
			factory:[],
			storage:[{
				type:0,
				storage:"生产入库"
			},{
				type:1,
				storage:"退货入库"
			}],
			tableData: [],
			productVisible: false
		};
	},
	mounted : function(){
		var user = JSON.parse(sessionStorage.getItem('user'));
		this.form.CID=user.QyNum;

	},
	methods: {
		SelectStorage(){},
		AddStorage(){
			this.dialogVisible=true;
		},
		UpdataStorage(){},
		DisableStorager(){},
		SetStorage(){

			this.dialogVisible=false;
		},
		restForm(){},
		SetStorage(){}
	}
}
</script>

<style scoped>
.title{
  text-align: left;
}
.btn{
	margin:0 0 10px 30px;
}
.el-select{
	display: inline;
}
</style>


// WEBPACK FOOTER //
// src/pages/dealerStorage.vue